module.exports = __webpack_public_path__ + "img/banner-hen-kr.e7ccf9ae.png";